import type { AddressPayload } from '~/types/global'
import type { TaxonomyItems } from '../taxonomies/types'

export const formatOrderTitle = (order: {
  qualifications: TaxonomyItems<'qualifications'>
  jobTitle?: string
}) => {
  const qualificationName = order.qualifications.map((q) => q.name).join(' · ')
  return `${!order.jobTitle ? qualificationName : order.jobTitle}`
}

type OrderContractFieldsInput = {
  jobTitle?: string
  address?: AddressPayload
  contractTerm?: number | null
  contractStart?: string | null
  contractEnd?: string | null
}

export const buildOrderContractFields = ({
  jobTitle,
  address,
  contractTerm,
  contractStart,
  contractEnd
}: OrderContractFieldsInput): Record<string, unknown> => {
  const fields: Record<string, unknown> = {}

  if (jobTitle) {
    fields.jobTitle = jobTitle
  }
  if (address) {
    fields.address = address
  }
  if (contractTerm) {
    fields.contractTerm = `/v1/taxonomies/contract_terms/${contractTerm}`
  }
  if (contractStart) {
    fields.contractStart = contractStart
  }
  if (contractEnd) {
    fields.contractEnd = contractEnd
  }

  return fields
}
